import React, { FC, useEffect } from 'react';
import { Button, Form, InputNumber, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { rules } from 'common/helpers/form.helper';
import { DEFAULT_VALUE_1 } from 'common/config';
import { IFormValue, IGoodsShort } from 'common/models';
import { GoodsCardMin } from 'entities/Goods/components/GoodsCardMin';

interface IComponentProps {
  open: boolean;
  goods: IGoodsShort | null;
  loading: boolean;
  onClose: () => void;
  onAdd: (value: number, onSuccess: () => void) => void;
}

export const RequestAddGoodsModal: FC<IComponentProps> = ({ open, goods, loading, onClose, onAdd }) => {
  const [form] = useForm();

  const handleClose = () => {
    if (loading) {
      return;
    }

    form.resetFields();
    onClose();
  };

  const onSubmit = (value: IFormValue) => {
    onAdd(value.count, handleClose);
  };

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ count: DEFAULT_VALUE_1 });
    }
  }, [open]);

  if (!goods) {
    return null;
  }

  return (
    <Modal
      rootClassName="redesign modal"
      width={420}
      centered
      open={open}
      onCancel={handleClose}
      destroyOnClose
      closeIcon={false}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button key="apply" className="button-sm primary" onClick={form.submit} loading={loading}>
          Добавить в заказ
        </Button>,
      ]}
    >
      <div className="text-h4 mb-3">Выберите количество товаров</div>

      <div className="text-tag color-dark-grey mb-6">
        На указанное количество будет создана поставка. При необходимости количество можно изменить позже, если будет доставлена
        только часть заказа.
      </div>

      <div className="mb-6">
        <GoodsCardMin good={goods} />
      </div>

      <Form form={form} requiredMark={false} layout="vertical" onFinish={onSubmit}>
        <Form.Item label="Количество" name="count" rules={[rules.required()]}>
          <InputNumber placeholder="Введите количество" controls={false} suffix="шт" precision={0} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
